import { get } from "@/shared/api/api-client";
import { injectable } from "inversify";

@injectable()
export class LogisticsDataService {
  async getBusinessOfferLogsticsData({
    warehouse_id,
    trade_id,
    destination_id,
  }: {
    warehouse_id: number;
    trade_id: number;
    destination_id: number;
  }) {
      const res = await get(`${PUBLIC_API_URL}/destination_trades`, { warehouse_id, trade_id, destination_id });
      return res;
  }
}
